(function() {
var headroom = new Headroom(document.querySelector("header"), {
    tolerance: 5,
    offset : 205,
    classes: {
      initial: "animated",
      pinned: "bounceInDown",
      unpinned: "bounceOutUp"
    }
});
headroom.init();
}());



var f = (function () {
  
var navbarHeight = new $("#header").outerHeight();
  
var marginHeight = navbarHeight+"px"; 
  
document.documentElement.style.setProperty(`--navbarheight`, marginHeight)

  
});

$(document).ready(f);
$(window).resize(f);


